import { jwtDecode } from "jwt-decode";
import { clearThemePalette } from "./themePalette";

export const permissionChecker = (
  permissions,
  userPermission,
  user,
  typeCompany
) => {
  try {
    if (userPermission.includes("POWER_USER")) return true;

    if (typeCompany.includes("ALL") && userPermission.includes("ADMIN")) {
      return true;
    }

    if (
      user?.Company?.companyTypeId === "CLIENTE" &&
      !typeCompany.includes("ALL")
    ) {
      return false;
    }

    // if (
    //   permissions.includes("POWER_USER") &&
    //   userPermission.includes("ADMIN") &&
    //   user.Company.companyId
    // ) {
    //   return false;
    // }

    // if (["ADMIN", "POWER_USER"].includes(userPermission)) return true;

    return permissions.includes(userPermission);
  } catch (error) {
    return false;
  }
};

export const getUserId = () => {
  try {
    const token = localStorage.getItem("token");
    const { user } = jwtDecode(token);

    return user.id;
  } catch (error) {
    return 0;
  }
};

export const removeToken = () => {
  localStorage.removeItem("token");
  /* A cor era da empresa de quem saiu; a tela de login volta ao tema padrão em
     vez de exibir a marca de outra pessoa para o próximo que entrar. */
  clearThemePalette();
  window.location.href = "/login";
};
